import { Box, Button, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"
import useWindowWidth from "../../hooks/useWindowWidth"

const PageNotFound = () => {
    const navigate = useNavigate()
    const windowWidth = useWindowWidth()
    return (
        <Box display={"flex"} justifyContent={"center"} pt={{ xs: windowWidth < 376 ? '130px' : '70px', xl: "40px", lg: '90px', md: '90px', sm: '90px' }} flexDirection={"column"} alignItems={"center"} width={"100%"}>
            <Typography pt={"40px"} variant="h1" fontSize={100}>
                404
            </Typography>
            <Box mt={2} fontWeight={600} fontSize={30} >
                Not Found
            </Box>
            <Typography my={2}>
                Try searching for something else
            </Typography>

            <Button onClick={() => { navigate(`/${window.location.search}`) }} style={{ width: "auto" }}>
                New Search
            </Button>
        </Box>
    )
}

export default PageNotFound